import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { MathfieldElement } from "mathlive";
import "mathlive/fonts.css";

// Fonts come from the bundle (fonts.css above) and the typing sounds are not needed.
MathfieldElement.fontsDirectory = null;
MathfieldElement.soundsDirectory = null;

// Visual equation editor (MathLive): type or pick fractions, roots, powers and symbols from the on-screen
// keyboard instead of writing LaTeX. `value` is only read on mount; changes are reported as LaTeX.
function MathField({ value, onChange, autoFocus }) {
  const ref = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const field = ref.current;
    field.value = value;
    field.mathVirtualKeyboardPolicy = "manual";
    const handleInput = () => onChangeRef.current(field.value);
    field.addEventListener("input", handleInput);
    const focusTimer = autoFocus ? setTimeout(() => field.focus(), 0) : null;
    return () => {
      field.removeEventListener("input", handleInput);
      clearTimeout(focusTimer);
      // The on-screen keyboard belongs to the page, not the field, so it would outlive the dialog.
      window.mathVirtualKeyboard?.hide();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <math-field ref={ref} style={{ display: "block", fontSize: "1.6rem", padding: "6px 8px", width: "100%" }} />;
}

MathField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
};

export default MathField;
